export default {
  getMasterUpdateIndex: state => state.masterUpdateIndex,
  getAllMaterials: (state) => {
    if (state.allMaterials) return state.allMaterials.map(material => material);
    return [];
  },
  getUserMaterials: (state) => {
    let materials = [];
    if (state.realizations?.length) {
      materials = state.allMaterials.filter(el => el.isActive).filter(el => state.realizations.some(f => f.id === el.id));
    }
    return materials;
  },
};
